(function(){
  'use strict';

  /**
   * @ngdoc factory
   * @name HcConvert
   * @desc manejo de highchart con estructuras existentes de graficos, con Datos
   *       variables y multiples series
   */
  angular.module('irricrops')
       .factory('HcConvert', ['Config','$rootScope', function(Config, $rootScope) {


              function HChart( json, config ) {
                angular.extend( this, {
                  week: json,
                  originalData : json,
                  config : config,
                  dataChart: []
                });
                this.$refreshHighchartConfig();
              }

              //lista de funciones para manejar los graficos highchart
              HChart.prototype = {
                $changeEje: function (newEje) {
                  this.config.eje.slice(0, this.config.eje);
                  angular.extend(this.config.eje, newEje);
                  this.$refreshHighchartConfig();
                },
                $getOriginalData: function () {
                  return this.originalData;
                },
                $getDataChart: function(){
                  return this.dataChart;
                },
                //TODO crear eje con fechas

                /**
                 * @doc function
                 * @name transform
                 * @desc transforma la lista de datos de la semana en una lista
                 *       de datos para highchart
                 * TODO manejarlo de manera privada
                 *
                 */
                transform: function (){

                  //recorre las series de datos en el config
                  angular.forEach(this.config.series, function(ser) {
                    //empty array
                    if(angular.isDefined(this.dataChart[ser.column])){
                      this.dataChart[ser.column].splice(0, this.dataChart[ser.column].length);
                    }else{
                      this.dataChart[ser.column] = [];
                    }
                    //recorre los dias de la semana, que contienen los datos
                    angular.forEach(this.week, function(day, key) {
                      if(day[ser.column] === null){
                        this.dataChart[ser.column].push(null);
                      }else{
                        this.dataChart[ser.column].push(Math.round(day[ser.column] *100)/100);
                      }
                    }, this);

                  }, this);
                },
                /**
                 * @doc function
                 * @name $refreshHighchartConfig
                 * @desc crea y refresca el object de configuracion para
                 *       los graficos highchart
                 */
                $refreshHighchartConfig : function () {
                  this.transform();
                  //datos para grafico de riego porogramado y etb
                  this.highchartsConfig = angular.copy(this.config.json);
                  this.highchartsConfig.xAxis.categories = this.config.eje;
                  this.highchartsConfig.title.text = this.config.title;

                  //funcion agregada para ser llamada cuando el grafico se carga
                  //esto redimenciona el grafico
                  //https://github.com/pablojim/highcharts-ng/issues/128
                  this.highchartsConfig.func = function (chart) {
                    $rootScope.$evalAsync(function () {
                        //chart.reflow();
                        $(window).resize();
                        //The below is an event that will trigger all instances of charts to reflow
                        //$rootScope.$broadcast('highchartsng.reflow');
                    });
                  };

                  if (angular.isDefined(this.config.limit)) {
                      this.highchartsConfig.yAxis.plotBands[0].to = this.config.limit;
                  }

                  var i = 0;
                  this.highchartsConfig.series.splice(0, this.highchartsConfig.length);
                  angular.forEach(this.config.series, function(con, key) {
                    this.highchartsConfig.series[i]= {
                                type: angular.isDefined(con.type) ? con.type : 'spline',
                                name: con.label,
                                data: this.dataChart[con.column],
                                color: con.color,
                                marker: (con.type == "scatter" ? {} : {
                                    lineWidth: 2,
                                    lineColor: con.color,
                                    fillColor: 'white'
                                })
                    };
                    if(angular.isDefined(con.marker)){
                      this.highchartsConfig.series[i].marker = con.marker;
                    }
                    if(con.suffix !== undefined){
                      this.highchartsConfig.series[i].tooltip = {
                        valueSuffix : con.suffix
                      };
                    }
                    i++;
                  }, this);
                  return this.highchartsConfig;
                },
                $getHighchartConfig:function () {
                  return this.highchartsConfig;
                }
              };


              // the public widget API
              return {
                instance: HChart
              };

       }]);



})();
